import type { MotorPickerEntry } from '../../../utils/electronicsDashboardUtils';
import { useChoosePortsToolbar } from './useChoosePortsToolbar';

/** Header toolbar for multi-port mechanism stream widgets. */
export function useChooseMechanismsToolbar({
  show,
  isHistoricMode,
  mechanisms,
  selectedPorts,
  onSelectedPortsChange,
  disabled,
  selectedPortsKey,
}: {
  show: boolean;
  isHistoricMode: boolean;
  mechanisms: readonly MotorPickerEntry[];
  selectedPorts: readonly number[];
  onSelectedPortsChange: (ports: number[]) => void;
  disabled?: boolean;
  selectedPortsKey: string;
}) {
  return useChoosePortsToolbar({
    show,
    isHistoricMode,
    entries: mechanisms,
    selectedPorts,
    onSelectedPortsChange,
    disabled,
    selectedPortsKey,
    chooseButtonI18nKey: 'dashboard.mechanismWidget.chooseMechanisms',
    chooseButtonDefault: 'Choose Mechanism',
    chooseAllI18nKey: 'dashboard.mechanismWidget.chooseAll',
    chooseAllDefault: 'Choose all',
  });
}
